module.exports = __webpack_public_path__ + "img/project-analysis.2fa738b.svg";